import React, { useState } from "react";
import { Grid, Box, Typography, Divider } from "@mui/material";
import { captionImageCaptionStyle, paraStyle } from "../../screens/JaldiLab/Chapters/ChapterList";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import _ from "lodash";
import ChapterDialog from "../Dialog/ChapterDialog";
import useCustomLogic from "../../Hooks/UseCustomLogic";

const ImageWithCaption = ({
  imageSrc,
  caption,
  captionText,
  height,
  creditLabel = "",
  creditValue = "",
  zoomImgStyle = "",
  imageDescription = [],
  className = ""
}) => {
  const isCaption = _.startsWith(caption, "Figure");
  const [isDialog, setIsDialog] = useState(false);
  const { isXs, isSm } = useCustomLogic();
  let isResponsive = (isXs || isSm);

  const captionImageCaptionStyle = {
    maxWidth: !isResponsive && "910px",
    padding: `0px ${!isResponsive ? '15px' : '10px'}  0px ${!isResponsive && '10px'}`,
    // padding: `0px ${!isXs ? '15px' : '10px'}  0px ${!isXs && '10px'}`,
    lineHeight: "27px",
    textAlign: !isResponsive ? "center" : "justify",
    // textAlign: !isXs ? "center" : "justify",
    fontFamily: "lato",
    fontSize: "18px",
    fontWeight: 500,
    fontStyle: "italic",
    color: "#1D1D1D",
  };

  const captionTextStyle = {
    width: "100%",
    fontStyle: "italic",
    paddingLeft: !isResponsive && "20px",
    color: "rgb(85, 85, 85)",
  }

  const handleOpenDialog = () => {
    setIsDialog(true);
  };

  const handleCloseDialog = () => {
    setIsDialog(false);
  };

  return (
    <>
      <div
        style={{
          display: !isResponsive ? "flex" : "grid",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "25px 0px",
          gap: isResponsive && "5px"
        }}
      >
        <div
          style={{
            width: "95%",
            height: !isResponsive && (height || "100%"),
            display: (isResponsive && imageSrc.length == 1) ? "" : "flex",
            gap: "10px",
          }}
        >
          {imageSrc &&
            imageSrc.map((elem, index) => {
              return (
                <Zoom>
                  <img
                    key={index}
                    src={elem}
                    alt="Image_src"
                    className={className}
                    style={{
                      width: "100%",
                      height: !isResponsive && (zoomImgStyle?.height || "100%"),
                      objectFit: zoomImgStyle?.objectFit || "contain",
                      marginRight: imageSrc.length > 1 ? "10px" : "0px",
                    }}
                  />
                </Zoom>
              );
            })}
        </div>

        {imageSrc.length > 0 && (
          <Typography
            style={captionTextStyle}
          >
            {captionText}
          </Typography>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Divider style={{ flexGrow: 1, borderBottom: "1px solid red" }} />
        <div style={{ textAlign: "center" }}>
          <Typography style={captionImageCaptionStyle}>{caption}</Typography>
          <Box display={!isResponsive ? "flex" : "inline-block"} justifyContent={"center"}>
            {creditValue && (
              <span
                style={{
                  fontFamily: "lato",
                  fontWeight: 500,
                  fontStyle: "italic",
                  fontSize: "12px",
                  color: "#1D1D1D",
                }}
              >
                {creditLabel}:
                <span
                  style={{
                    fontFamily: "lato",
                    fontWeight: 500,
                    fontStyle: "italic",
                    color: "red",
                    paddingLeft: "4px",
                  }}
                >
                  {creditValue}
                </span>
              </span>
            )}
            <button
              type="button"
              style={{
                fontSize: "12px",
                fontFamily: "lato",
                fontWeight: 500,
                fontStyle: "italic",
                color: "red",
                paddingLeft: "4px",
                cursor: "pointer",
                border: 0,
                background: "transparent",
              }}
              onClick={() => handleOpenDialog()}
            >
              {creditValue && "|"} {isCaption ? "Figure" : "Image"} Description
            </button>
          </Box>
        </div>
        <Divider style={{ flexGrow: 1, borderBottom: "1px solid red" }} />
      </div>
      {isDialog && (
        <ChapterDialog
          open={isDialog}
          onCloseDialog={handleCloseDialog}
          title={`${isCaption ? "Figure" : "Image"} Description`}
          no={2}
        >
          <Grid
            container
            mt={3}
            flexDirection={"column"}
            sx={{ margin: "0px 20px" }}
          >
            <Typography
              variant="h3"
            >
              {imageDescription?.title}
            </Typography>
            <Box mt={1}>
              <p style={paraStyle}>
                {imageDescription?.para1}
              </p>
              <p style={paraStyle}>
                {imageDescription?.para2}
              </p>
              {imageDescription?.items}
            </Box>
          </Grid>
        </ChapterDialog>
      )}
    </>
  );
};

export default ImageWithCaption;
